<template>
  <b-card class="">
    <template #header>
      <div class="d-flex justify-content-between align-items-center w-100 pb-1" style="border-bottom: 2px solid rgb(238, 238, 238);">
        <h4 class="text-dark m-0">
          Consultations
        </h4>
      </div>
    </template>

    <div class="card-body">
      <div v-if="consultationsData && consultationsData.length > 0">
        <div v-for="(consultation, index) in consultationsData" :key="index" class="">
          <div class="">
            <div>
              <p>Doctor: {{ getValueFromSource(consultation, 'doctor.full_name') }}</p>
              <p>Date Created: {{ formatDate(getValueFromSource(consultation, 'created')) }}</p>
              <p>Status: 
                <span>
                  <b-badge
                  pill
                  :variant="`light-${resolveStatusVariant(consultation.status)}`"
                  class="text-capitalize"
                  >
                    {{ getUserStatusText(consultation.status) }}
                  </b-badge>
                </span>
              </p>

              <p>
                Consultation Type: {{ startCase(getValueFromSource(consultation, 'consultation_type')) }}
              </p>

              <div v-if="getValueFromSource(consultation, 'consultation_type') === 'medical'">
                <p v-if="getValueFromSource(consultation, 'presenting_complaint_history')">
                  Presenting Complaint History: {{ startCase(getValueFromSource(consultation, 'presenting_complaint_history')) }}
                </p>
                
                <p v-else>
                  There is no complaint history for this consultation.
                </p>
              </div>
  
              <div class="d-flex align-items-center">
                <b-link
                v-if="can('consultations:CanUpdate')"
                :to="{ name: `admin-${getValueFromSource(consultation, 'consultation_type')}-consultation-edit`, params: { id: getValueFromSource(consultation, 'id') } }"
                class="font-weight-bold d-flex align-items-center"
                >
                  <div><feather-icon icon="EditIcon" /></div>
                  <div class="align-middle ml-50">Edit</div>
                </b-link>
  
                <b-link
                v-if="can('consultations:CanView')"
                :to="{ name: `admin-${getValueFromSource(consultation, 'consultation_type')}-consultation-summary`, params: { id: getValueFromSource(consultation, 'id') } }"
                class="font-weight-bold d-flex align-items-center ml-2"
                >
                  <div><feather-icon icon="EyeIcon" /></div>
                  <div class="align-middle ml-50">View</div>
                </b-link>
              </div>
            </div>
            <hr v-if="((index + 1 ) !== consultationsData.length)" class="mt-1" />
          </div>
          <br />
        </div>
      </div>

      <div v-else>
        <p class="lead">No medical history for this patient.</p>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BButton,
  BAvatar,
  BRow,
  BCol,
  BBadge,
  BAlert,
  BLink,
  BDropdown,
  BDropdownItem,
  BDropdownGroup
} from 'bootstrap-vue'

import {
  startCase
} from "lodash";

import Ripple from 'vue-ripple-directive';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'


export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BLink,
    BAvatar,
    BBadge,
    BAlert,
    BDropdown,
    BDropdownItem,
    BDropdownGroup,

    ToastificationContent
  },
  props: {
    patientData: {
      type: Object,
      required: true,
    },
    consultationsData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    startCase
  },
}
</script>


<style scoped lang="scss">
@import '~@core/scss/base/bootstrap-extended/variables.scss'; 

.text-lg {
  font-size: 16px !important;
}
.nav-link {
  color: gray;
  // letter-spacing: 2px;
}
.nav-item.active {
  .nav-link {
    color: $primary-color;
  }
}
</style>
